const API_PATHS = {
  FETCH_USER_DETAILS: 'user/me',
};

export default API_PATHS;
